import React from "react";
import { useParams, Link } from "react-router-dom";
// import PageNotes from "../../pages/common/pagenotes";
import { useAuth } from "../../../usercontext";
import Student911TopMenu from "../studentInfo/student911topmenu"
import PageNotes from "../../pages/common/pagenotesnew";
import AcademicAssessment from "./sublist/academicAssessment";

export default function InstructorStudentAcademicAssessment() {
  let { slug } = useParams();
  const { profile, setProfile } = useAuth();

  return (
    <>
      <Student911TopMenu slug={slug} activeMenu={"Academic"} />
      <PageNotes
        type={"StudentAcademicsAssessment"}
        pageName={"StudentAcademicsAssessment"}
        studentId={slug}
        instructorId={profile.id}
      />
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
            <AcademicAssessment slug={slug} />
          </div>
        </div>
      </div>
    </>
  );
}
